import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Typography, TextField, InputAdornment, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { getchatuserlist } from "../../../slice/usersSlice";
import { getSocket } from "../../../socket/socket.js";
import UserListItem from './SmallUserListItem.jsx';
import UserListItemSkeleton from '../UserListItemSkeleton.jsx';

const UserList = ({ selectedUser, onSelectUser }) => {
  const dispatch = useDispatch();
  const { getchatuser, status, error } = useSelector((state) => state.users);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    dispatch(getchatuserlist());
  }, [dispatch]);

  useEffect(() => {
    const socket = getSocket();
    const handleOrderChange = () => { dispatch(getchatuserlist()); };
    socket.on("userOrderChange", handleOrderChange);
    socket.on("userStatusChange", handleOrderChange);
    return () => {
      socket.off("userOrderChange", handleOrderChange);
      socket.off("userStatusChange", handleOrderChange);
    };
  }, [dispatch]);

  if (status === "loading") {
    return (
      <Box sx={{ padding: '16px' }}>
        {Array.from({ length: 8 }).map((_, i) => (
          <UserListItemSkeleton key={i} />
        ))}
      </Box>
    );
  }

  if (status === "failed") return <Typography sx={{ p: 2, color: 'error.main' }}>Error: {error}</Typography>;

  const filteredUsers = getchatuser?.filter((user) => {
    const query = searchQuery.toLowerCase();
    return (
      user.name?.toLowerCase().includes(query) ||
      user.lastName?.toLowerCase().includes(query) ||
      user.email?.toLowerCase().includes(query) ||
      user._id?.toLowerCase().includes(query)
    );
  });

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', background: '#FFFFFF' }}>
      {/* Search Header */}
      <Box sx={{ padding: '14px 16px', borderBottom: '1px solid #F1F5F9' }}>
        <Typography 
          sx={{ 
            fontSize: '11px', 
            fontWeight: 800, 
            color: '#1E293B', 
            textTransform: 'uppercase', 
            letterSpacing: '0.08em',
            marginBottom: '10px'
          }}
        >
          Recent Chats
        </Typography>
        <TextField
          size="small"
          placeholder="Search people..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          fullWidth
          sx={{ 
            '& .MuiOutlinedInput-root': { 
              height: '34px', 
              borderRadius: '12px', 
              fontSize: '12px',
              background: '#F8FAFC',
              '& fieldset': { borderColor: 'transparent' },
              '&:hover fieldset': { borderColor: '#E2E8F0' },
              '&.Mui-focused fieldset': { borderColor: '#2a78d1' }
            } 
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ fontSize: '16px', color: '#94A3B8' }} />
              </InputAdornment>
            ),
          }}
        />
      </Box>

      {/* User List Scrollable Area */}
      <Box sx={{ flex: 1, overflowY: 'auto', py: 1, '&::-webkit-scrollbar': { width: '4px' } }}>
        {filteredUsers?.map((user) => (
          <UserListItem
            key={user._id}
            listUser={user}
            isSelected={selectedUser && selectedUser._id === user._id}
            onSelectUser={onSelectUser}
          />
        ))}
        {filteredUsers?.length === 0 && (
          <Box sx={{ p: 4, textAlign: 'center' }}>
            <Typography sx={{ fontSize: '13px', color: '#94A3B8' }}>No users found</Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default UserList;

